export const updateDocumentInsideStateList = (documentType, documentChanges) => documents =>
    documents.map(document =>
        document.documentType === documentType
            ? {
                  ...document,
                  ...documentChanges,
              }
            : document
    );
